import { extend } from 'lodash';
import { base } from './environment.baseProd';

export const environment = extend(base, {
  title: 'PipeTech Portal',
  productFamily: '54ec96d7ef84a8c0288ae986'
});



// WEBPACK FOOTER //
// /builds/pentech-portal/client/src/environments/environment.ts